import React from "react";
import { injectIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import avatarVideo from "../../assets/avatares/mute-green.webm";
import avatarVideoMp4 from "../../assets/avatares/mute-green.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

function Scenario5Context1() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-end h-75 px-4">
						<video autoPlay playsInline preload="auto" muted loop className="mb-4 pb-5">
							<source src={avatarVideoMp4} type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur-green h-100 px-5 pt-5">
						<div className="recuadro-white recuadro-border-green txtTexto1 mb-3 w-100">
							<h3 className="txtTitulos green mb-3">Seguimiento y continuidad asistencial</h3>
							<p className="txt16 mb-2">
								En esta fase el paciente ya ha completado el ciclo agudo y entra en un periodo de seguimiento
								estrecho con su equipo habitual. El objetivo es vigilar la evolución clínica, la tolerancia al
								tratamiento y la calidad de vida, ajustando el plan cuando sea necesario.
							</p>
							<p className="txt16 mb-0">
								Antes de la pregunta, repasa con el grupo qué datos considerarías prioritarios en la próxima
								visita (síntomas, analítica, imagen, adherencia y apoyo psicosocial) y cómo comunicarías los
								cambios al paciente y a la familia.
							</p>
						</div>
						<div className="mt-2 d-flex align-items-center justify-content-end w-100">
							<NextButton
								navigateTo={ROUTES.SCENARIO5_QUIZ1}
								activeScenario={activeScenario}
								color="green"
								textColor="white"
							/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario5Context1);
